export default __webpack_public_path__ + "static/media/AMZN_FR_DE_BULKY.9402ed24.svg";